/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePracticeBranchDto,
  ErrorResponse,
  GetPracticeDetailsForPatient200Response,
  PracticeListResponseDto,
  PracticeProfileDetailDto,
  PracticeProfileViewDto,
  ProviderDto,
  UpdatePracticeBranchDto,
  UpdatePracticeDto,
} from '../models/index';
import {
    CreatePracticeBranchDtoFromJSON,
    CreatePracticeBranchDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPracticeDetailsForPatient200ResponseFromJSON,
    GetPracticeDetailsForPatient200ResponseToJSON,
    PracticeListResponseDtoFromJSON,
    PracticeListResponseDtoToJSON,
    PracticeProfileDetailDtoFromJSON,
    PracticeProfileDetailDtoToJSON,
    PracticeProfileViewDtoFromJSON,
    PracticeProfileViewDtoToJSON,
    ProviderDtoFromJSON,
    ProviderDtoToJSON,
    UpdatePracticeBranchDtoFromJSON,
    UpdatePracticeBranchDtoToJSON,
    UpdatePracticeDtoFromJSON,
    UpdatePracticeDtoToJSON,
} from '../models/index';

export interface GetPracticeDetailsForPatientRequest {
    practiceId: string;
}

export interface GetPracticesListRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    city?: string;
    sortBy?: GetPracticesListSortByEnum;
    sortOrder?: GetPracticesListSortOrderEnum;
}

export interface PracticeControllerCreateBranchRequest {
    createPracticeBranchDto: CreatePracticeBranchDto;
}

export interface PracticeControllerDeleteBranchRequest {
    branchId: string;
}

export interface PracticeControllerUpdateBranchRequest {
    branchId: string;
    updatePracticeBranchDto: UpdatePracticeBranchDto;
}

export interface PracticeControllerUpdatePracticeRequest {
    updatePracticeDto: UpdatePracticeDto;
}

/**
 * 
 */
export class PracticeApi extends runtime.BaseAPI {

    /**
     * Patient-facing: returns practice info, branches and providers for a given practiceId.
     * Get practice details for patient
     */
    async getPracticeDetailsForPatientRaw(requestParameters: GetPracticeDetailsForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPracticeDetailsForPatient200Response>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling getPracticeDetailsForPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/details/{practiceId}`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPracticeDetailsForPatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Patient-facing: returns practice info, branches and providers for a given practiceId.
     * Get practice details for patient
     */
    async getPracticeDetailsForPatient(requestParameters: GetPracticeDetailsForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPracticeDetailsForPatient200Response> {
        const response = await this.getPracticeDetailsForPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get practice (doctor) profile information including provider details and branch information
     * Get practice profile information
     */
    async getPracticeProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeProfileDetailDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeProfileDetailDtoFromJSON(jsonValue));
    }

    /**
     * Get practice (doctor) profile information including provider details and branch information
     * Get practice profile information
     */
    async getPracticeProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeProfileDetailDto> {
        const response = await this.getPracticeProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get practice profile view (read-only) with practice-level information only from practices table. Does not include provider-specific fields like firstName, lastName, npi, or specialty.
     * Get practice profile view
     */
    async getPracticeProfileViewRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeProfileViewDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/profile/view`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeProfileViewDtoFromJSON(jsonValue));
    }

    /**
     * Get practice profile view (read-only) with practice-level information only from practices table. Does not include provider-specific fields like firstName, lastName, npi, or specialty.
     * Get practice profile view
     */
    async getPracticeProfileView(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeProfileViewDto> {
        const response = await this.getPracticeProfileViewRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get paginated list of practices with search, filter, and sort options for patients to find suitable clinics
     * Get list of practices for patients
     */
    async getPracticesListRaw(requestParameters: GetPracticesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getPracticesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get paginated list of practices with search, filter, and sort options for patients to find suitable clinics
     * Get list of practices for patients
     */
    async getPracticesList(requestParameters: GetPracticesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeListResponseDto> {
        const response = await this.getPracticesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get provider profile information
     * Get provider profile information
     */
    async getProviderProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeProfileDetailDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/provider/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeProfileDetailDtoFromJSON(jsonValue));
    }

    /**
     * Get provider profile information
     * Get provider profile information
     */
    async getProviderProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeProfileDetailDto> {
        const response = await this.getProviderProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get providers of practice
     * Get providers of practice
     */
    async getProvidersOfPracticeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProviderDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/providers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderDtoFromJSON));
    }

    /**
     * Get providers of practice
     * Get providers of practice
     */
    async getProvidersOfPractice(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProviderDto>> {
        const response = await this.getProvidersOfPracticeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async practiceControllerCreateBranchRaw(requestParameters: PracticeControllerCreateBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createPracticeBranchDto'] == null) {
            throw new runtime.RequiredError(
                'createPracticeBranchDto',
                'Required parameter "createPracticeBranchDto" was null or undefined when calling practiceControllerCreateBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/branches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePracticeBranchDtoToJSON(requestParameters['createPracticeBranchDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async practiceControllerCreateBranch(requestParameters: PracticeControllerCreateBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.practiceControllerCreateBranchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async practiceControllerDeleteBranchRaw(requestParameters: PracticeControllerDeleteBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling practiceControllerDeleteBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/branches/{branchId}`.replace(`{${"branchId"}}`, encodeURIComponent(String(requestParameters['branchId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async practiceControllerDeleteBranch(requestParameters: PracticeControllerDeleteBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.practiceControllerDeleteBranchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async practiceControllerGetBranchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/branches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async practiceControllerGetBranches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.practiceControllerGetBranchesRaw(initOverrides);
    }

    /**
     */
    async practiceControllerUpdateBranchRaw(requestParameters: PracticeControllerUpdateBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['branchId'] == null) {
            throw new runtime.RequiredError(
                'branchId',
                'Required parameter "branchId" was null or undefined when calling practiceControllerUpdateBranch().'
            );
        }

        if (requestParameters['updatePracticeBranchDto'] == null) {
            throw new runtime.RequiredError(
                'updatePracticeBranchDto',
                'Required parameter "updatePracticeBranchDto" was null or undefined when calling practiceControllerUpdateBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice/branches/{branchId}`.replace(`{${"branchId"}}`, encodeURIComponent(String(requestParameters['branchId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePracticeBranchDtoToJSON(requestParameters['updatePracticeBranchDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async practiceControllerUpdateBranch(requestParameters: PracticeControllerUpdateBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.practiceControllerUpdateBranchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async practiceControllerUpdatePracticeRaw(requestParameters: PracticeControllerUpdatePracticeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updatePracticeDto'] == null) {
            throw new runtime.RequiredError(
                'updatePracticeDto',
                'Required parameter "updatePracticeDto" was null or undefined when calling practiceControllerUpdatePractice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/practice`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePracticeDtoToJSON(requestParameters['updatePracticeDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async practiceControllerUpdatePractice(requestParameters: PracticeControllerUpdatePracticeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.practiceControllerUpdatePracticeRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetPracticesListSortByEnum = {
    Name: 'name',
    City: 'city'
} as const;
export type GetPracticesListSortByEnum = typeof GetPracticesListSortByEnum[keyof typeof GetPracticesListSortByEnum];
/**
 * @export
 */
export const GetPracticesListSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetPracticesListSortOrderEnum = typeof GetPracticesListSortOrderEnum[keyof typeof GetPracticesListSortOrderEnum];
